import React, { useMemo } from 'react';
import PickingPageHeader from 'app/containers/OrderDetails/HeaderOrderDetails/PrintOrder/PickingPage/PickingPageHeader';
import { Workstation } from 'app/containers/OrderDetails/types';
import { Trolley } from 'app/models/Trolley';
import { PartOrder } from 'app/models/PartOrder';
import PickingSectionView from './PickingSectionView';

interface Props {
  order: PartOrder;
  trolleys: Trolley[];
  workstation: Workstation;
}

const PickingCornerPageView = ({ order, trolleys, workstation }: Props) => {
  const pickingSubPages = useMemo(() => {
    const pages: Trolley[][] = [[]];
    let counter = 0;
    let currentPageIndex = 0;

    trolleys.forEach((trolley, trolleyIndex) => {
      pages[currentPageIndex].push(trolley);
      counter += 1;

      trolley.production.forEach((piece, pieceIndex) => {
        counter += 1;
        const isPageBreakNeeded =
          (counter % 17 === 0 || (pieceIndex === 0 && (counter - 1) % 17 === 0)) &&
          trolleyIndex < trolleys.length - 1;

        if (isPageBreakNeeded) {
          currentPageIndex += 1;
          pages.push([]);
        }
      });
    });

    return pages;
  }, [order.id, trolleys]);

  return (
    <>
      {pickingSubPages.map((subpage, indexPage) => (
        <div key={`${order.id}-${indexPage}`} className="page page-break">
          <PickingPageHeader
            order={order}
            workstation={workstation}
            indexPage={indexPage + 1}
            nbPages={pickingSubPages.length}
          />
          {indexPage === 0 && (
            <div className="flex items-start justify-start label-signatures">
              <div className="flex w-1/3">Preparé par</div>
              <div className="flex w-1/3">Vérifié par</div>
              {order.isHomeTour && !order.isKewlox ? (
                <div className="flex w-1/3">Emballé par</div>
              ) : (
                <div style={{ border: 0 }}></div>
              )}
            </div>
          )}
          <div className="flex flex-col">
            {subpage.map(trolley => (
              <div key={trolley.id}>
                <PickingSectionView
                  pieces={trolley.production}
                  productName={trolley.production?.[0]?.product?.name}
                  showPickingAddress={false}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default PickingCornerPageView;
